// Domain-specific configurations for Coming Soon pages
export const domainConfigs = {
  "mikrotik.courses": {
    siteName: "MIKROTIK.COURSES",
    tagline: "OFFICIAL MIKROTIK TRAINING CENTER",
    headline: "COMING\nSOON",
    description: "Professional MikroTik certification courses delivered by certified trainers. Gain hands-on experience and industry-recognized credentials.",
    launchMessage: "We're working hard to bring you the best network engineering training platform.",
  },
  "rimpianto.com": {
    siteName: "RIMPIANTO.COM",
    tagline: "SOMETHING AMAZING IS BREWING",
    headline: "COMING\nSOON",
    description: "We're crafting something extraordinary. A new digital experience is on its way.",
    launchMessage: "Stay tuned for the big reveal. Sign up to be the first to know.",
  },
  "rimpianto.courses": {
    siteName: "RIMPIANTO.COURSES",
    tagline: "PROFESSIONAL TRAINING PLATFORM",
    headline: "COMING\nSOON",
    description: "Expert-led courses designed to elevate your skills. Industry-recognized certifications await.",
    launchMessage: "We're building an exceptional learning experience just for you.",
  }
};

// Default config (fallback)
export const defaultConfig = {
  siteName: "COMING SOON",
  tagline: "SOMETHING NEW IS COMING",
  headline: "COMING\nSOON",
  description: "We're working on something exciting. Stay tuned for updates.",
  launchMessage: "Sign up to be notified when we launch.",
};

// Shared config across all domains
export const siteConfig = {
  emailPlaceholder: "Enter your email",
  buttonText: "NOTIFY ME",
  successMessage: "Thank you! We'll notify you when we launch.",
  footerText: "© 2026 dog hunter AG Zug ZG Switzerland"
};

// Helper function to get domain config
export const getDomainConfig = () => {
  const hostname = window.location.hostname;
  
  // Check for exact match
  if (domainConfigs[hostname]) {
    return { ...domainConfigs[hostname], ...siteConfig };
  }
  
  // Check for www prefix
  const withoutWww = hostname.replace(/^www\./, '');
  if (domainConfigs[withoutWww]) {
    return { ...domainConfigs[withoutWww], ...siteConfig };
  }
  
  // Return default for localhost or unknown domains
  return { ...defaultConfig, ...siteConfig };
};

export const subscribers = [];
